import styled from "@emotion/styled";
import React from 'react';
import { i18n } from 'src/common';
import { Flex, Text } from 'src/components';
import { baseWidths, colors } from 'src/theme';
import { Card } from './card';

const CardStyle = styled(Card)({
  maxWidth: baseWidths.mobile,
  width: '100%',
  borderWidth: 1,
  borderStyle: 'dashed',
  borderColor: colors.border3,

  '&:hover': {
    borderColor: colors.primary
  }
})

const LinkStyle = styled.a({
  textDecoration: 'none',
  color: colors.primary,
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 700,

  '&:hover': {
    color: '#8E00CC'
  }
})

export interface RequestAgentCardV2Props {
  title?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  background?: string;
}

export const RequestAgentCardV2: React.FC<RequestAgentCardV2Props> = ({
  title = i18n.t('components.cards.requestAgentCard.title'),
  buttonLabel = i18n.t('components.cards.requestAgentCard.buttonLabel'),
  onButtonClick = () => console.log('click'),
  background = 'transparent'
}) => (
  <CardStyle radius={12} padding={16} background={background}>
    <Flex gap={8} justify='space-between'>
      <Text type='base'>{title}</Text>
      <LinkStyle href='#' onClick={(e) => {e.preventDefault(); onButtonClick();}}>
        {buttonLabel}
      </LinkStyle>
    </Flex>
  </CardStyle>
);
